// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import 'chartkick/chart.js'
import 'bootstrap'
import { delegate } from 'jquery-events-to-dom-events'

import './init_map'
import turboConfirm from './custom_confirm'

import { application } from 'controllers/application'
import 'controllers'

import * as Turbo from "@hotwired/turbo"
Turbo.config.forms.confirm = turboConfirm

global.$ = $

delegate('shown.bs.modal')

document.addEventListener("turbo:load", () => {
  $('#agreements-modal').modal({
    keyboard: false,
    backdrop: 'static'
  })

  $('.timeline-toggler').on('click', (e) => {
    $(e.currentTarget).parent().next('.timeline').find('.timeline-toggable').toggleClass('d-none')
  })
})

document.addEventListener('turbo:before-cache', () => {
  application.controllers.forEach(controller => {
    if (typeof controller.teardown === 'function') {
      controller.teardown()
    }
  })
})

window.addEventListener('load', (event) => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service_worker.js')
      .catch((err) => {
        console.error(err)
      })
  } else {
    console.error('Service Worker Not Supported')
  }
})
